export default "__VITE_ASSET__DZUXz5hT__"